<div class="widget-wrapper" [ngClass]="'theme-' + [site]">
  <calc-my-prime-renov [workSelectedValue]="workType"></calc-my-prime-renov>
</div>
